import { render } from "./ServiciosColectivos.vue?vue&type=template&id=a88edfe6&ts=true"
import script from "./ServiciosColectivos.vue?vue&type=script&lang=ts"
export * from "./ServiciosColectivos.vue?vue&type=script&lang=ts"

import "./ServiciosColectivos.vue?vue&type=style&index=0&id=a88edfe6&lang=css"

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__